// extracted by mini-css-extract-plugin
module.exports = {"divide":"E4LrudzhDpHZZJ3obvD-VA==","horizontal":"CytOYnAaHmUgJSdRQ6fg9A==","vertical":"+mX4K0TDj80z6vvCM98S2w=="};